import React from "react";
import ContentList from "./ContentList";
import "fabric-webpack";
import DesignCanvas from "../components/DesignCanvas";
import Image from "../components/Image";
import img from "../assets/pepper.png";

const Home = () => {
  let width = window.innerWidth;
  let height = window.innerHeight;
  return (
    <section>
      <ContentList
        title={["music videos", "commercial"]}
        content={[
          [
            {
              src: "mus-df.mp4",
              artist: "ravyn lenae | dominic fike",
              song: "reputation",
              href: "https://player.vimeo.com/video/1179917490?portrait=0",
            },
            {
              src: "mus-oakisland.mp4",
              artist: "zach bryan",
              song: "oak island",
              href: "https://player.vimeo.com/video/1007928555?portrait=0",
            },
            {
              src: "mus-nineball.mp4",
              song: "nine ball",
              artist: "zach bryan",
              href: "https://player.vimeo.com/video/910178392?portrait=0",
            },
            {
              src: "mus-boysoffaith.mp4",
              song: "boys of faith",
              artist: "zach bryan | bon iver",
              href: "https://player.vimeo.com/video/891565754?portrait=0",
            },
            {
              src: "mus-oklahomasmokeshow.mp4",
              artist: "zach bryan",
              song: "oklahoma smokeshow",
              href: "https://player.vimeo.com/video/1090616228?portrait=0",
            },
            {
              src: "mus-driverslicense.mp4",
              artist: "olivia rodrigo",
              song: "driver's license",
              href: "https://player.vimeo.com/video/1090616137?portrait=0",
            },
                        {
              src: "mus-crossthestreet.mp4",
              artist: "junior varsity",
              song: "cross the street",
              href: "https://player.vimeo.com/video/1006996286?portrait=0",
            },
            {
              src: "mus-coldblood.mp4",
              artist: "junior varsity",
              song: "cold blood",
              href: "https://player.vimeo.com/video/1090616060?portrait=0",
            },
            {
              src: "mus-pruneyoutalkfunny.mp4",
              artist: "gus dapperton",
              song: "world class cinema",
              href: "https://player.vimeo.com/video/296035724?portrait=0",
            },
            {
              src: "mus-worldclasscinema.mp4",
              artist: "gus dapperton",
              song: "prune, you talk funny",
              href: "https://player.vimeo.com/video/245921641?portrait=0",
            },
            {
              src: "mus-prettylittlefears.mp4",
              artist: "6lack/jcole",
              song: "pretty little fears",
              href: "https://player.vimeo.com/video/295231225?portrait=0",
            },
            {
              src: "mus-cold.mp4",
              artist: "rich brian",
              song: "cold",
              href: "https://player.vimeo.com/video/256605384?portrait=0",
            },
            {
              src: "mus-willhe.mp4",
              artist: "joji",
              song: "will he",
              href: "https://player.vimeo.com/video/239819546?portrait=0",
            },
            {
              src: "mus-crew.mp4",
              artist: "goldlink",
              song: "crew",
              href: "https://player.vimeo.com/video/205822673?portrait=0",
            },
          ],
          [
            {
              src: "com-bm.mp4",
              artist: "benjamin moore",
              song: "timeless",
              href: "https://player.vimeo.com/video/1169667602?portrait=0",
            },
            {
              src: "com-rocket.mp4",
              artist: "rocket",
              song: "own the dream super bowl 2025",
              href: "https://player.vimeo.com/video/1066751659?portrait=0",
              
            },
            {
              src: "com-ross.mp4",
              artist: "ross",
              song: "back to school",
              href: "https://player.vimeo.com/video/1112379991?portrait=0",
            },
            {
              artist: "converse all star",
              song: "spring / summer 2023",
              href: "https://player.vimeo.com/video/1090616046?portrait=0",
              src: 'com-converse.mp4'
            },
            {
              artist: "facebook",
              song: "deaf hoops",
              href: "https://player.vimeo.com/video/548915948?portrait=0",
              src: "com-facebook.mp4"
            },
            {
              artist: "ralph lauren",
              song: "when gigi met gigi",
              href: "https://player.vimeo.com/video/582252550?portrait=0",
              src: "com-gigi.mp4"
            },
            {
              src: "com-citi.mp4",
              artist: "citi",
              song: "black wall street",
              href: "https://player.vimeo.com/video/680567753?portrait=0",
            },
            {
              src: "com-sky.mp4",
              artist: "skyexpress",
              song: "in with the new",
              href: "https://player.vimeo.com/video/1090616201?portrait=0",
            },
            {
              src: "com-converse2.mp4",
              artist: "converse",
              song: "love fearlessly",
              href: "https://player.vimeo.com/video/391507549?portrait=0",
            },
            {
              src: "com-diamond.mp4",
              artist: "natural diamond council",
              song: "michelle monaghan",
              href: "https://player.vimeo.com/video/1090616104?portrait=0",
            },
            {
              src: "com-new-balance.mp4",
              artist: "new balance",
              song: "all terrain",
              href: "https://player.vimeo.com/video/1090616121?portrait=0",
            },
            {
              src: "com-nowness.mp4",
              artist: "nowness",
              song: "bulldozer",
              href: "https://player.vimeo.com/video/209694300?portrait=0",
            },
            {
              src: "com-vogue.mp4",
              artist: "vogue",
              song: "gus dapperton",
              href: "https://player.vimeo.com/video/228230434?portrait=0",
            },
            {
              src: "com-adidas.mp4",
              artist: "adidas",
              song: "milan",
              href: "https://player.vimeo.com/video/251199538?portrait=0",
            },
            {
              src: "com-nike.mp4",
              artist: "nike / footlocker",
              song: "before the bite",
              href: "https://player.vimeo.com/video/265476512?portrait=0",
            },
          ],
        ]}
      />
      <DesignCanvas>
        <Image
          url={img}
          scale={0.1}
          top={parseInt(height) - 200}
          left={parseInt(width) - 160}
        />
      </DesignCanvas>

      <div className="footerQuote">
        <span>personality based</span>
        <span>style conscious</span>
        <span>storytelling</span>
      </div>
    </section>
  );
};

export default Home;
